import { Typography } from "@mui/material";
import PropTypes from "prop-types";

const style = (editing) => ({
    padding: '0px 2.5px',
    '&:focus': {
        outlineColor: 'secondary.light'
    }
})

/**
 * EditableTypography Component
 *
 * This component extends the functionality of a Typography component from a UI library.
 * It is editable if the 'editing' prop is true.
 *
 * @param {Object} props - The props for this component.
 * @property {boolean} editing - If true, the Typography becomes editable.
 * @property {string} value - The display content in the Typography.
 * @property {Function} onChange - A callback function to handle changes in the Typography content.
 * @property {Object} sx - Additional styling configurations.
 *
 * @returns {JSX.Element} - A Typography component that is conditionally editable.
 */
const EditableTypography = ({ editing, value, onChange, sx, ...rest }) => {
    return <Typography
        {...rest}
        sx={{
            ...style(editing),
            outlineColor: 'secondary',
            ...sx
        }}
        contentEditable={`${editing}`}
        suppressContentEditableWarning={true}
        onInput={(evt) => onChange(evt.target.innerText)}
    >
        {value}
    </Typography >
}

EditableTypography.propTypes = {
    editing: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    sx: PropTypes.object,
    // ... other prop types
};

export default EditableTypography;